<template>
  <zg-module
    v-bind="moduleProps"
    class="zg-video-section"
  >
    <slot
      slot="sub-title"
      name="sub-title"
    />

    <div
      v-if="items && items.length"
      :class="['videos', {
        'videos--large': large,
        'videos--medium': !large
      }]"
    >
      <zg-video
        v-for="(item, index) in items"
        :key="index"
        :title="item.title"
        :date="item.date"
        :author="item.author"
        :image="item.media"
        :url="item.link && item.link.href"
        :size="large ? 'large' : 'medium'"
        :background="cardsWithBackground ? cardBackground : null"
      />
    </div>
  </zg-module>
</template>

<script>
  import module from '../../../mixins/module.js'
  import ZgVideo from '../../ZgVideo/ZgVideo.vue'
  import ZgModule from '../ZgModule/ZgModule.vue'

  export default {
    name: 'ZgVideoSection',
    components: {
      ZgModule,
      ZgVideo
    },
    mixins: [module],
    props: {
      items: {
        type: Array,
        required: true,
        validator: items => items.every(({ media, link }) => (media && media.src) && (link && link.href))
      },
      cardsWithBackground: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      large () {
        return this.items?.length <= 2
      }
    }
  }
</script>

<style lang="scss" scoped>
  .videos {
    display: flex;
    flex-direction: column;
    gap: rem(16px);

    @include mq(medium) {
      flex-direction: row;
      flex-wrap: wrap;
      gap: rem(24px);
    }

    & > figure {
      flex-basis: 100%;
      flex-grow: 0;
      flex-shrink: 0;
    }
  }

  .videos--medium {
    & > figure {
      @include mq(medium) {
        flex-basis: calc(100% / 3 - (#{rem(24px)} * 2 / 3));
      }
    }
  }

  .videos--large {
    & > figure {
      @include mq(medium) {
        flex-basis: calc(100% / 2 - #{rem(12px)});
      }
    }
  }
</style>
